import Handler from '@/core/domain/usecase/handler';

const deleteTruckDriverRepository = (axios) => async (id) => {
    try {
        const response = await axios.delete(`/truck-driver/${id}`)
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default deleteTruckDriverRepository